export default __webpack_public_path__ + "static/frame1-ec4823fabc2065ed876478ab51f75de2.jpg";